
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Scroller from 'vux/src/components/scroller/index.vue'
import LoadMore from 'vux/src/components/load-more/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import Popup from 'vux/src/components/popup/index.vue'

export default {
directives: {
TransferDom
},
components: {
Flexbox,
FlexboxItem,
Scroller,
LoadMore,
XDialog,
Confirm,
Toast,
Popup
},
data() {
return {
QuestionList: [],
onFetching: false,
bottomCount: 1,
AnswerList:[],
QuestionId:"",
FriendList:[],
CollectList:[],
FriendGroup:[],//好友目录
CollectGroup:[],//收藏目录
show:false,
show1:false,
show2:false,
show3:false,
show31:false,
FriendID:"",
CollectID:"",
content:"",
title:"",
Publish:"",
showPositionValue:false,
texts:"",
}
},
created() {
this.getQstList();
this.getFriendList();
this.getCollectList();
},
mounted() {
if(!this.GLOBAL.isLogin){
var hrefUrl = location.host;
hrefUrl = "http://softtone.jqweike.com/login?callback=" + encodeURIComponent(hrefUrl);
document.getElementById("a").href = hrefUrl;
}else{
document.getElementById("content").style.height = window.innerHeight * 0.15 +"px";
document.getElementById("titles").style.height = window.innerHeight * 0.03 +"px";
}
},
methods: {
CutName:function(name){
if(name.length>3){
return name.substring(0,2)+"..";
}else{
return name;
}
},
CutString:function(String,index){
if(String.length>index){
return String.substring(0,index)+".";
}else{
return String;
}
},

getFriendGroup:function(){
this.$api.GetGroupList()
.then((data) => {
if(data.data.Status==0){
this.FriendGroup = data.data.Data.rows;
}
})
},

getFriendList:function(){
this.FriendList = [];
this.$api.GetAllFriendList()
.then((data) => {
if(data.data.Status == 0){

}
this.FriendList = data.data.Data.rows;
})
},

getCollectList:function(){
this.$api.CollectContent("qtn")
.then((data) => {
if(data.data.Status == 0){
this.CollectList = data.data.Data.rows;
}
})
},

getCollectGroup:function(){
this.$api.CollectCatalog("qtn")
.then((data) => {
if(data.data.Status==0){
this.CollectGroup = data.data.Data.rows;
}
})
},

getQstList:function(){
this.QuestionList =[];
this.$tyh.GetByChapterID(this.GLOBAL.ChapterID)
.then((data) => {
if(data.data.Status !=0 ){
return ;
}
var VideoID = data.data.Data.resource.ID;
this.$tyh.getRelatedid(VideoID, "1")
.then((data) => {
for(var i in data.data.Data.rows){
var listData = {
Context:data.data.Data.rows[i].Context,
CreateTime:data.data.Data.rows[i].CreateTime,
HeaderUrl:data.data.Data.rows[i].HeaderUrl,
ID:data.data.Data.rows[i].ID,
UserID:data.data.Data.rows[i].UserID,
ProjectNo:data.data.Data.rows[i].ProjectNo,
Title:data.data.Data.rows[i].Title,
UserName:data.data.Data.rows[i].UserName,
count:data.data.Data.rows[i].count
}
this.QuestionList.push(listData);
}
});
})
},
onScrollBottom() {
if (this.onFetching) {

} else {
this.onFetching = true
setTimeout(() => {
this.bottomCount += 1;
this.$tyh.getRelatedid(this.$route.params.IDCode, this.bottomCount)
.then((data) => {
if (data.data.Data.rows != 0) {
this.QuestionList=this.QuestionList.concat(data.data.Data.rows);
if (data.data.Data.rows.length < 10) {
document.getElementById("loadMore").style.display = "none";
}
} else {
var load = document.getElementById("loadMore");
if(load.style!="none")
load.style.display = "none"
}
});
this.onFetching = false
}, 100)
}
},

dateFormat: function (time) {
var date = new Date(time);
var year = date.getFullYear();
/* 在日期格式中，月份是从0开始的，因此要加0
* 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05 */
var month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
var hours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
var minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
var seconds = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();

return year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds;
},

QuestDetails:function(QntId){
this.$tyh.getAnswer(QntId)
.then((data) => {
if(data.data.Status !=0 ){
return ;
}
this.AnswerList = data.data.Data;
this.QuestionId = QntId;
this.show = true;
})
},

AnswerAdd:function(){
var textAnswer = this.Publish;
var QntId = this.QuestionId;
if(textAnswer == ""||textAnswer==undefined){
this.texts = "请输入回答内容"
this.showPositionValue = true;
}else{
this.Publish ="";

this.$tyh.AddAnswer(textAnswer,QntId)
.then((data) => {
if(data.data.Data == "添加成功"){
this.$tyh.getAnswer(QntId)
.then((data) => {
if(data.data.Status !=0 ){
return ;
}
this.AnswerList = data.data.Data;
})
}
})
}
},
close:function(){
this.show = false;
document.getElementById("Publish").placeholder = "";
document.getElementById("Publish").value = "";
document.getElementById("Publish").style.borderColor = "#000000";
},

AddQue:function(){
var title = this.title;
var content = this.content;
if(title=="" || title == undefined){
this.showPositionValue=true;
this.texts = "请输入标题"
}else{
this.title = "";
this.content = "";


var CourseID = this.GLOBAL.IDCode;
var VideoID =  this.GLOBAL.ChapterID;

this.$tyh.GetByChapterID(VideoID)
.then((data) => {
if(data.data.Status !=0 ){
return ;
}
VideoID = data.data.Data.resource.ID;
this.$tyh.AddQuestion(CourseID,VideoID,title,content)
.then((data) => {
this.getQstList();
this.show1 = false;
this.showPositionValue=true;
this.texts = "提问成功"
})

})






}
},
close2:function(){
document.getElementById("titles").value = "";
document.getElementById("content").value = "";
document.getElementById("titles").placeholder = "";
document.getElementById("titles").style.borderColor = "#808080";
this.show1 = false
},
close3:function(){
this.getQstList();
this.show = false;
},

isFriend:function(userid){
if(localStorage.getItem("UserID") == userid){
return false;
}
for(var i in this.FriendList){
if(this.FriendList[i].CareForUserID == userid){
return false;
}

}
return true;
},

addFriend:function(type,userid){
if(type == "open"){
this.getFriendGroup();
this.show2 = true;
this.FriendID = userid;
}
if(type == "add"){
var UserId = this.FriendID;

var obj = document.getElementById("FriendCatalog"); 
var index = obj.selectedIndex; 
var id = obj.options[index].id; 
if(id != undefined && id !=null && id !=""){
this.$api.AddFriend(UserId,id)
.then((data) => {
if(data.data.Status ==0 ){
this.getFriendList();
this.show2 = false;
alert("添加成功")
}
})
}else{
alert("添加失败")
}

}

},

addFriendGroup:function(){
var name = document.getElementById("AddFriendCatalog").value;
if(name == ""||name == null ){
document.getElementById("AddFriendCatalog").placeholder = "不可为空";
document.getElementById("AddFriendCatalog").style["border-color"] = "red";
}else{
document.getElementById("AddFriendCatalog").placeholder = "";
document.getElementById("AddFriendCatalog").style["border-color"] = "#333333";

this.$api.AddGroupList(name)
.then((data) => {
if(data.data.Status ==0 ){
this.getFriendGroup();
document.getElementById("AddFriendOpen").style.display = "block";
document.getElementById("AddFriendSure").style.display ="none";
document.getElementById("AddFriendCatalog").style.display = "none";
}
})
}
},

isCollect:function(courseID){
for(var i in this.CollectList){
if(this.CollectList[i].ContextID == courseID){
return false;
}
}
return true;
},

deleteCollect:function(id){
var deleteSure = confirm("确认取消收藏？");

var deleteID ="";
if(deleteSure){
for(var i in this.CollectList){

if(id == this.CollectList[i].ContextID){
deleteID = this.CollectList[i].ID;
}

}
if(deleteID !=""){
this.$api.DeleteConllect(deleteID)
.then((data) => {
if(data.data.Status == 0){
this.getCollectList();
}
})
}

}
},

addCollectGroup:function(value){
if(value != "" && value != null && value != undefined){
this.$api.AddCollectGroupList("qtn",value)
.then((data) => {
this.getCollectGroup();
if(data.data.Status ==0 ){
this.texts = "添加成功"
}else{
this.texts = data.data.Data
}
})
}else{
this.texts = "请输入正确目录名"
}
this.showPositionValue = true;
},

addCollect:function(type,Qthid){
if(type == "open"){
this.getCollectGroup();
this.show3 = true;

this.CollectId = Qthid;
}
if(type == "add"){

var obj = document.getElementById("CollectCatalog"); 
var index = obj.selectedIndex; 
var id = obj.options[index].id; 

if(id != undefined && id !=null && id !=""){
var addBody ={
FavTypeNo: "qtn",
CategoryID: id,
ContextID:this.CollectId,
}

this.$api.addConllect(addBody)
.then((data) => {
if(data.data.Status == 0){
this.getCollectList();
this.show3 = false;
this.texts = "收藏成功"
this.showPositionValue = true;
/*									//添加日志
this.AddLog("StoreVideo");

this.$api.SetScore("CollectionScore")
.then((data) => {
if(data.data.Status == 1){

}
})*/
}
})
}else{
this.texts = "收藏失败"
this.showPositionValue = true;
}
}

},
}
}



// WEBPACK FOOTER //
// ./src/views/Index/Course/Question.vue